import { createApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
// import 'ant-design-vue/dist/antd.css'; // 引入样式


createApp(App).use(Antd).mount('#app')
